<mat-toolbar color="primary">
	<header class="main-header">
		<!-- Small screen only -->
		<ng-container *ngIf="isHandset$ | async; else desktopHeader">
			<div class="location">
				<img src="/assets/images/ApplioSpacesLogo.png" alt="Applio Spaces" class="logo" />
				<h1 class="current">{{ leaf?.name }}</h1>
			</div>
			<!-- <div>
				<h1 class="current">{{ leaf?.name }}</h1>

			</div> -->
			<button type="button" aria-label="Toggle sidenav" mat-icon-button color="primary" (click)="drawer.toggle()">
				<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
			</button>
		</ng-container>
		<!-- Large screen only -->
		<ng-template #desktopHeader>
			<div class="location">
				<mat-icon *ngIf="root?.icon" [svgIcon]="root?.icon" color="primary"></mat-icon>
				<h1 class="current">
					{{ root?.name }}<ng-container *ngFor="let child of children">, {{ child.name }}</ng-container>
				</h1>
			</div>
			<div class="actions">
				<button mat-icon-button aria-label="Go to notifications" title="Notifications">
					<mat-icon class="icon" svgIcon="top-bar-notification"></mat-icon>
				</button>
				<a mat-icon-button routerLink="account" aria-label="Go to account settings" title="Account settings">
					<mat-icon class="icon" svgIcon="top-bar-settings"></mat-icon>
				</a>
			</div>
			<div *ngIf="user$ | async as user" class="user">
				<span>{{ user.name }}</span>
				<img [src]="user.avatar ? user.avatar : '/assets/images/user-avatar.svg'" alt="avatar" class="avatar" />
				<button mat-flat-button color="primary" (click)="onLogout()">Sign out</button>
			</div>
		</ng-template>
	</header>
</mat-toolbar>